import { useState } from "react";
import "./App.css";
import Login from "./pages/Login";
import Home from "./pages/Home";
import { BrowserRouter, Routes, Route, redirect } from "react-router-dom";
import Languages from "./components/Languages";
// import TestReponsive from './pages/page-essential/TestResponsive';
import PackageCategories from "./pages/PackageCategories";
import TravelGuide from "./pages/TravelGuide";
import BlogCategory from "./pages/BlogCategory";
import jwt_decode from "jwt-decode";
import { AuthContext, authType } from "./context/AuthContext";
import NotFound from "./pages/NotFound";
import PrivateRoutes from "./HOC/PrivateRoutes";
// import { LangContext, langsType } from './context/LanguageContext';
// import { useFetch } from './hooks/UseFetch';
import Packages from "./pages/Packages";
import Amenities from "./pages/Amenities";
import AddPkgAmenities from "./pages/AddPkgAmenities";
import { LanguageProvider } from "./context/LanguageContext";
import Review from "./pages/Review";
import Booking from "./pages/Booking";
import MetaTags from "./pages/MetaTags";

function App() {
  const [userLoggedIn, setUserLoggedIn] = useState<authType>({
    status: false,
    user: "",
  });

  // const allLanguages = LangService()

  // console.log(userLoggedIn)

  // const navigate = useNavigate()

  const handleLogout = () => {
    localStorage.removeItem("token");

    setUserLoggedIn({
      status: false,
      user: "",
    });
    return redirect("/");
  };

  console.log(userLoggedIn);

  const [constructorHasRun, setConstructorHasRun] = useState(false);
  const constructor = () => {
    if (constructorHasRun) return;
    const token = localStorage.getItem("token");

    if (token) {
      const decoded: { exp: number; email: string; iat: number; role: string } =
        jwt_decode(token);

      setUserLoggedIn({
        status: true,
        user: decoded.email as any,
      });

      if (new Date(decoded.exp * 1000) < new Date()) {
        handleLogout();
      }
    }
    setConstructorHasRun(true);
  };
  // const { data, errMsg, loading } = useFetch('lang/findAll')
  constructor();

  return (
    <div>
      {/* <TestReponsive /> */}
      <BrowserRouter>
        {/* <LangContext.Provider value={allLanguages}> */}
        <LanguageProvider>
          <AuthContext.Provider value={[userLoggedIn, setUserLoggedIn]}>
            <Routes>
              <Route element={<PrivateRoutes />}>
                <Route path="/" element={<Home />} />
                <Route path="/languages" element={<Languages />} />
                <Route
                  path="/package-categories"
                  element={<PackageCategories />}
                />
                <Route path="/travel-guide" element={<TravelGuide />} />
                <Route path="/blog-category" element={<BlogCategory />} />
                <Route path="/packages" element={<Packages />} />
                <Route path="/amenities" element={<Amenities />} />
                <Route path="/booking" element={<Booking />} />
                <Route path="meta-tags" element={<MetaTags />} />
                <Route
                  path="/add_pkg_amenities"
                  element={<AddPkgAmenities />}
                />
                <Route path="/review" element={<Review />} />
              </Route>
              {userLoggedIn?.status === false && (
                <Route path="/login" element={<Login />} />
              )}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthContext.Provider>
        </LanguageProvider>
        {/* </LangContext.Provider> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
